import { Packages } from '~shared/constants/pricing';

import { TEAMS_PACKAGES } from '~pricing/lib/constants';
import SummaryTransformer from '~pricing/transformers/classes/SummaryTransformer';
import PlanTransformers from '~pricing/transformers/classes/PlanTransformers';

import FeatureList from './features';
import { SummaryFeatureTransformer } from './types';

/**
 * We can override feature rules by the configuration no accessor methods.
 * There should be only one instance of the SummaryTransformer class
 */
const summaryTransformer = SummaryTransformer.getInstance();

/**
 * Retrieve specific feature based on experiment or certain overrides.
 * This falls back to the default configuration for transformers
 * @param options
 * @returns SummaryFeatureTransformer
 */
export default function getSummaryFeatureTransformer(
  packageName: Packages,
  treatment: string
): SummaryFeatureTransformer {
  const planTransformers = new PlanTransformers(FeatureList, treatment).initializeList();
  /* if packages to display is not configured based on route and featureList config,
     this will fail to ensure the developer knows what they want to achieve */
  const transformerConfigObject = planTransformers[packageName];
  if (transformerConfigObject && TEAMS_PACKAGES.includes(packageName)) {
    return summaryTransformer.teamsSummaryFeatureTransform(transformerConfigObject);
  }
  return summaryTransformer.individualSummaryFeatureTransform(transformerConfigObject);
}
